<div class="popover absolute bg-white rounded p-4" [style]="style" [class]="position">
  <div
    class="close-popover absolute bg-white size-[34px] rounded-bl-md flex top-0 right-0 cursor-pointer"
  >
    <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
  </div>
  <div (click)="playVideo()">
    <img src="/assets/thumb/{{ thumb }}" [alt]="title" />
    <div class="absolute top-4 w-10 ml-[111px] mt-[54px]">
      <img src="/assets/icons/play-video.svg" alt="Play video" />
    </div>
  </div>
  <div class="font-bold mt-2">{{ title | translate }}</div>
  <div class="opacity-70">{{ description | translate }}</div>
  @if (knowledgeBaseUrl) {
    <a
      class="block mt-2 text-brand"
      target="_blank"
      [href]="knowledgeBaseUrl | translate"
    >
      {{ 'SHARE.SPEAKER.SEE_MORE' | translate }}
    </a>
  }
</div>
